import * as theme  from '@zero/design-tokens/build/js/variables';


export const normalOrange = theme.ZrColorBrandPrimary02Medium
export const lightOrange = theme.ZrColorBrandPrimary02Lightest
export const normalBlue = "#0088A5"
export const lightBlue = "#76D9F8"

type SliderColorStructure = {normal: string, light: string}

export type SliderColorsOptions = 'orange' | 'blue'

const sliderColors: SliderColorsAndValue = {
    'orange': {normal: theme.ZrColorBrandPrimary02Medium, 
               light: theme.ZrColorBrandPrimary02Lightest}, 
      'blue': {normal: "#0088A5", light: "#76D9F8"}
    }

export type SliderColorsAndValue = {[key in SliderColorsOptions]: SliderColorStructure}

type ColorTyes = 'normal' | 'light'

export function getSliderColor(color: SliderColorsOptions, type: ColorTyes = 'normal'): string {    
    return sliderColors[color][type]
}